import { useState } from "react";
import * as React from "react";
import { itemColors } from "../App";

export const Palette = (props: {
  selectedColor: number;
  setSelectedColor: (index: number) => void;
}) => {
  return (
    <div className="palette" style={{ display: "flex" }}>
      {itemColors.map((color, index) => (
        <div
          onClick={(e) => {
            props.setSelectedColor(index);
            e.stopPropagation();
          }}
          style={{
            height: "45px",
            width: "45px",
            borderRadius: "50%",
            backgroundColor: color,
            boxShadow:
              props.selectedColor === index
                ? `0 0 0 2px ${itemColors[index]}`
                : "none",
            border: "2px solid white",
            margin: "3px",
          }}
        ></div>
      ))}
    </div>
  );
};
